import { Chart as ChartJS, registerables } from 'chart.js';
import useNotification from 'hooks/useNotification';
import is from 'is_js';
import { useAppContext } from 'providers/AppProvider';
import { useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { Outlet, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { registerNavigation } from 'helpers/navigation';

ChartJS.register(...registerables);

const App = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const navigate = useNavigate();
  const {
    config: { navbarPosition }
  } = useAppContext();

  const { NotificationContainer } = useNotification();

  // Registrar função de navegação para uso global
  useEffect(() => {
    registerNavigation(navigate);
  }, [navigate]);

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition]);

  return (
    <>
      <Outlet />
      <ToastContainer position='top-center' />
    </>
  );
};

export default App;
